"use client";

import { useEffect, useState } from "react";
import { PlatformsIcon } from "../../core";
import { ShareButtonProps } from "./props";
import styles from "./share-button.module.scss";

export default function ShareButton({ path }: ShareButtonProps) {
  const [isClient, setIsClient] = useState<boolean>(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  async function handleNavigatorShare() {
    await navigator.share({ url: path });
  }

  if (!isClient) return null;

  return (
    <>
      {typeof navigator != "undefined" &&
        typeof navigator.share == "function" && (
          <button
            className={`${styles.button} button`}
            onClick={handleNavigatorShare}
            aria-label="Compartilhar Veículo"
          >
            <PlatformsIcon
              icon="ic:round-share"
              className={`${styles["button__icon"]} button__icon`}
            />
          </button>
        )}
    </>
  );
}
